/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  GetExerciseQueryResponse,
  GetExercisePathParams,
  GetExercise401,
  GetExercise403,
  GetExercise404,
} from '../types/GetExercise.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetExerciseUrl(id: GetExercisePathParams['id']) {
  const res = { method: 'GET', url: `/exercises/${id}` as const };
  return res;
}

/**
 * @summary Get exercise by ID
 * {@link /exercises/:id}
 */
export async function getExercise(id: GetExercisePathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetExerciseQueryResponse, ResponseErrorConfig<GetExercise401 | GetExercise403 | GetExercise404>, unknown>({
    method: 'GET',
    url: getGetExerciseUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
